import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { pontoService } from '../../services/api';

const Relatorios = () => {
  const navigate = useNavigate();
  const [mostrarRelatorioPontos, setMostrarRelatorioPontos] = useState(false);
  const [filtros, setFiltros] = useState({
    dataInicio: '',
    dataFim: '',
    status: ''
  });
  const [relatorioData, setRelatorioData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleGerarRelatorioPontos = async () => {
    if (!filtros.dataInicio || !filtros.dataFim) {
      toast.error('Por favor, selecione as datas de início e fim');
      return;
    }

    setLoading(true);
    try {
      const response = await pontoService.relatorio(filtros);
      
      if (response.data.success) {
        setRelatorioData(response.data.relatorio);
        setMostrarRelatorioPontos(true);
        toast.success('Relatório gerado com sucesso!');
      } else {
        toast.error('Erro ao gerar relatório');
      }
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      toast.error(error.response?.data?.message || 'Erro ao gerar relatório');
    } finally {
      setLoading(false);
    }
  };

  const formatarData = (data) => {
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const formatarHora = (data) => {
    return new Date(data).toLocaleTimeString('pt-BR');
  };

  const calcularHorasTrabalhadas = (entrada, saida) => {
    if (!entrada || !saida) return '-';
    const diff = new Date(saida) - new Date(entrada);
    const horas = Math.floor(diff / (1000 * 60 * 60));
    const minutos = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    return `${horas}h ${minutos.toString().padStart(2, '0')}min`;
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">
        Relatórios
      </h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">Ponto</h3>
          <p className="text-gray-600 mb-4">Relatórios de presença</p>
          <button 
            onClick={() => setMostrarRelatorioPontos(true)}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Gerar
          </button>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">Frota</h3>
          <p className="text-gray-600 mb-4">Relatórios de veículos</p>
          <button 
            onClick={() => navigate('/relatorios/veiculos')}
            className="w-full bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors"
          >
            Gerar
          </button>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">Financeiro</h3>
          <p className="text-gray-600 mb-4">Relatórios de custos</p>
          <button className="w-full bg-purple-600 text-white py-2 px-4 rounded-lg hover:bg-purple-700 transition-colors">
            Gerar
          </button>
        </div>
      </div>

      {/* Modal de Relatório de Pontos */}
      {mostrarRelatorioPontos && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-11/12 max-w-6xl shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Relatório de Pontos
                </h3>
                <button
                  onClick={() => {
                    setMostrarRelatorioPontos(false);
                    setRelatorioData(null);
                  }}
                  className="text-gray-400 hover:text-gray-600"
                >
                  ✕
                </button>
              </div>

              {/* Filtros */}
              <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                <h4 className="text-md font-medium text-gray-900 mb-3">Filtros</h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Data Início</label>
                    <input
                      type="date"
                      value={filtros.dataInicio}
                      onChange={(e) => setFiltros(prev => ({ ...prev, dataInicio: e.target.value }))}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Data Fim</label>
                    <input
                      type="date"
                      value={filtros.dataFim}
                      onChange={(e) => setFiltros(prev => ({ ...prev, dataFim: e.target.value }))}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Status</label>
                    <select
                      value={filtros.status}
                      onChange={(e) => setFiltros(prev => ({ ...prev, status: e.target.value }))}
                      className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Todos</option>
                      <option value="aprovado">Aprovado</option>
                      <option value="pendente">Pendente</option>
                      <option value="rejeitado">Rejeitado</option>
                      <option value="ajustado">Ajustado</option>
                    </select>
                  </div>
                </div>
                <div className="mt-4">
                  <button
                    onClick={handleGerarRelatorioPontos}
                    disabled={loading}
                    className="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 disabled:opacity-50"
                  >
                    {loading ? 'Gerando...' : 'Gerar Relatório'}
                  </button>
                </div>
              </div>

              {/* Resultado do Relatório */}
              {relatorioData && (
                <div className="overflow-x-auto">
                  <div className="mb-4 p-3 bg-blue-50 rounded-lg">
                    <h4 className="font-medium text-blue-900">Período: {formatarData(relatorioData.periodo.inicio)} a {formatarData(relatorioData.periodo.fim)}</h4>
                    <p className="text-blue-700">Total de colaboradores: {relatorioData.totalColaboradores}</p>
                  </div>
                  
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Colaborador
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Data
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Primeira Batida
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Última Batida
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Período Total
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Total Batidas
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {relatorioData.dados.map((item, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            <div>
                              <div className="font-medium">{item._id.nome}</div>
                              <div className="text-gray-500">{item._id.matricula}</div>
                              <div className="text-gray-500">{item._id.departamento}</div>
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {formatarData(item._id.data)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {item.primeiraBatida ? formatarHora(item.primeiraBatida) : '-'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {item.ultimaBatida ? formatarHora(item.ultimaBatida) : '-'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {calcularHorasTrabalhadas(item.primeiraBatida, item.ultimaBatida)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {item.totalBatidas}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => {
                    setMostrarRelatorioPontos(false);
                    setRelatorioData(null);
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Relatorios;
